// extracted by mini-css-extract-plugin
export var checkboxImage = "index-module--checkbox-image--wWsii";
export var checkboxListWrapper = "index-module--checkbox-list-wrapper--ieknf";
export var checkboxTitle = "index-module--checkbox-title--bRI8h";